/* OnBarefoot — Stride PDP. (1) Numeric media counter ("1 / N") hooked to the
   Flickity gallery via the .is-selected class. (2) One-time reveal for the
   feature-proof stat visuals. Self-contained; no theme-internal dependencies. */

/* (1) Media counter */
(function () {
  function setup(container) {
    var slider = container.querySelector('.product-images');
    var counter = container.querySelector('.obf-media-counter');
    if (!slider || !counter) return;
    var cur = counter.querySelector('[data-obf-counter-current]');
    if (!cur) return;

    function update() {
      var slides = slider.querySelectorAll('.product-images__slide');
      if (!slides.length) return;
      var sel = slider.querySelector('.product-images__slide.is-selected');
      var idx = sel ? Array.prototype.indexOf.call(slides, sel) : 0;
      if (idx < 0) idx = 0;
      cur.textContent = idx + 1;
    }

    var mo = new MutationObserver(update);
    mo.observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });

    update();
    setTimeout(update, 250);
    setTimeout(update, 1000);
  }

  function init() {
    var containers = document.querySelectorAll('.product-image-container');
    for (var i = 0; i < containers.length; i++) setup(containers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* (3) "Read reviews" -> smooth scroll to the Judge.me widget (or configured anchor) */
(function () {
  var JUDGEME = '#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-widget, [id^="judgeme"], #shopify-product-reviews';

  function headerOffset() {
    var h = document.querySelector('.header-sticky--active .header, header[role="banner"], .thb-header');
    return h ? h.getBoundingClientRect().height + 12 : 20;
  }

  function findTarget(href) {
    var el = null;
    if (href && href.charAt(0) === '#' && href.length > 1) {
      try { el = document.querySelector(href); } catch (e) { el = null; }
    }
    if (!el) el = document.querySelector(JUDGEME);
    return el;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-obf-reviews-link]');
    if (!link) return;
    var target = findTarget(link.getAttribute('href'));
    if (!target) return; // let the default anchor jump happen
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
})();

/* (2) One-time reveal for feature-proof stat bars/levels */
(function () {
  function reveal(el) { el.classList.add('is-in'); }
  function init() {
    var els = document.querySelectorAll('[data-obf-animate]');
    var i;
    for (i = 0; i < els.length; i++) els[i].classList.add('obf-js');
    if (!('IntersectionObserver' in window)) {
      for (i = 0; i < els.length; i++) reveal(els[i]);
      return;
    }
    // Fire as soon as the section's top edge reaches ~10% up from the viewport
    // bottom. threshold:0 + rootMargin avoids the "never fires" bug on sections
    // taller than the viewport (e.g. the stacked barefoot cards on mobile, where
    // 25% of the whole section is never on-screen at once).
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    for (i = 0; i < els.length; i++) io.observe(els[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* (4) Item 2: arrow controls for the mobile colour-swatch scroller.
   Adds prev/next buttons that scroll the .obf-swatch-scroll row. Buttons appear
   only when the row overflows; tapping them scrolls, never selects a swatch. */
(function () {
  var ARROW_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeBtn(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'obf-swatch-nav obf-swatch-nav--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = dir === 'prev' ? ARROW_L : ARROW_R;
    return b;
  }

  function setup(scroller) {
    if (scroller.dataset.obfNav === '1') return;
    scroller.dataset.obfNav = '1';
    var fieldset = scroller.closest('.product-form__input--color') || scroller.parentNode;
    var prev = makeBtn('prev', 'Previous colours');
    var next = makeBtn('next', 'Next colours');
    fieldset.appendChild(prev);
    fieldset.appendChild(next);

    function overflow() { return scroller.scrollWidth - scroller.clientWidth > 4; }

    function refresh() {
      var hasOverflow = overflow();
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      if (!hasOverflow) return;
      var x = scroller.scrollLeft;
      prev.disabled = x <= 1;
      next.disabled = x >= (scroller.scrollWidth - scroller.clientWidth - 1);
    }

    function step(mult) {
      var amount = Math.max(scroller.clientWidth * 0.7, 120) * mult;
      if (scroller.scrollBy) scroller.scrollBy({ left: amount, behavior: 'smooth' });
      else scroller.scrollLeft += amount;
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
    scroller.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
    setTimeout(refresh, 400);
  }

  function init() {
    var rows = document.querySelectorAll('.obf-pdp-grid .product-form__input--color .obf-swatch-scroll');
    for (var i = 0; i < rows.length; i++) setup(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* (5) Item 3 safeguard: when product.js hides an unavailable option (CSS hides
   inputs with .is-disabled / data-available="false"), make sure a hidden option
   never stays selected, which would leave no valid variant and block Add to cart.
   If the checked radio in a variations fieldset is hidden, check the first visible
   available one and fire a change so the theme recomputes the variant. Scoped to
   the OBF PDP only. */
(function () {
  function isHidden(input) {
    return input.classList.contains('is-disabled') || input.getAttribute('data-available') === 'false';
  }

  function fix(root) {
    var fieldsets = root.querySelectorAll('.variations fieldset');
    for (var f = 0; f < fieldsets.length; f++) {
      var inputs = fieldsets[f].querySelectorAll('input[type="radio"]');
      if (!inputs.length) continue;
      var checked = null, firstOk = null, j;
      for (j = 0; j < inputs.length; j++) {
        if (inputs[j].checked) checked = inputs[j];
        if (!firstOk && !isHidden(inputs[j])) firstOk = inputs[j];
      }
      if (checked && isHidden(checked) && firstOk && firstOk !== checked) {
        firstOk.checked = true;
        firstOk.dispatchEvent(new Event('change', { bubbles: true }));
        return; // one change at a time; the resulting re-render re-runs this
      }
    }
  }

  function init() {
    var grids = document.querySelectorAll('.obf-pdp-grid variant-selects');
    for (var i = 0; i < grids.length; i++) {
      (function (vs) {
        // Run after initial setDisabled, and after every variant change re-render.
        setTimeout(function () { fix(vs); }, 300);
        vs.addEventListener('change', function () { setTimeout(function () { fix(vs); }, 250); });
      })(grids[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* (6) Item 5: count-up for the "Barefoot difference" stats.
   Each [data-obf-countup] holds text like "35% wider", "0mm drop", "65% lighter".
   We parse a leading number; if it's > 0 we animate 0 -> target once the stat
   scrolls into view (~900ms easeOut), keeping the suffix/prefix text intact.
   No number (or 0) just shows as-is. Respects prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function parse(text) {
    // Match an optional leading non-digit prefix, the number, then the rest.
    var m = String(text).match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
    if (!m) return null;
    return { prefix: m[1], target: parseFloat(m[2]), decimals: (m[2].split('.')[1] || '').length, suffix: m[3] };
  }

  function format(n, decimals) {
    return decimals > 0 ? n.toFixed(decimals) : String(Math.round(n));
  }

  function run(el) {
    if (el.dataset.obfCountupDone === '1') return;
    el.dataset.obfCountupDone = '1';
    var info = parse(el.textContent);
    if (!info || !(info.target > 0)) return; // nothing to count; leave text as-is
    if (reduce) return; // final value already shown

    var dur = 900, start = null, original = el.textContent;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      var val = info.target * eased;
      el.textContent = info.prefix + format(val, info.decimals) + info.suffix;
      if (p < 1) { requestAnimationFrame(step); }
      else { el.textContent = original; } // exact original string at the end
    }
    el.textContent = info.prefix + format(0, info.decimals) + info.suffix;
    requestAnimationFrame(step);
  }

  function init() {
    var els = document.querySelectorAll('[data-obf-countup]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { return; } // leave final text
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* (7) Item 4: mirror the live product price into the Add to cart button.
   The theme rewrites the OBF price block (.obf-price, inside #price-<section>)
   on every variant change. We copy its selling price into [data-obf-atc-price]
   and its compare-at (struck) into [data-obf-atc-compare], so the button price
   always matches the page exactly. We also hide the whole price group while the
   button is sold-out/unavailable (theme adds .sold-out / disabled). Scoped to
   the OBF PDP grid only. */
(function () {
  function setup(grid) {
    var btnWrap = grid.querySelector('[data-obf-atc]');
    if (!btnWrap) return; // only present on the OBF PDP (gated in Liquid)
    var nowOut = btnWrap.querySelector('[data-obf-atc-price]');
    var cmpOut = btnWrap.querySelector('[data-obf-atc-compare]');
    var priceBlock = grid.querySelector('.obf-price');
    var button = grid.querySelector('.single-add-to-cart-button');
    if (!nowOut || !priceBlock) return;

    function sync() {
      var nowEl = priceBlock.querySelector('.obf-price__now');
      var wasEl = priceBlock.querySelector('.obf-price__was');
      var soldOut = !button || button.disabled || button.classList.contains('sold-out') ||
        priceBlock.classList.contains('visibility-hidden');

      if (soldOut) { btnWrap.hidden = true; return; }
      btnWrap.hidden = false;

      if (nowEl) nowOut.textContent = nowEl.textContent.trim();
      if (cmpOut) {
        var wasText = wasEl ? wasEl.textContent.trim() : '';
        if (wasText) { cmpOut.textContent = wasText; cmpOut.hidden = false; }
        else { cmpOut.textContent = ''; cmpOut.hidden = true; }
      }
    }

    // Re-run whenever the price block is rewritten (variant change) or the
    // button state flips (sold-out toggling).
    var mo = new MutationObserver(sync);
    mo.observe(priceBlock, { childList: true, subtree: true, characterData: true });
    if (button) {
      new MutationObserver(sync).observe(button, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
    var vs = grid.querySelector('variant-selects');
    if (vs) vs.addEventListener('change', function () { setTimeout(sync, 350); });

    sync();
    setTimeout(sync, 600);
  }

  function init() {
    var grids = document.querySelectorAll('.obf-pdp-grid');
    for (var i = 0; i < grids.length; i++) setup(grids[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
